import React, { ReactElement } from 'react';
import { TFunction } from 'i18next';
import { FastField, FastFieldProps } from 'formik';
import TextField from '@material-ui/core/TextField';

export interface OrganizationDetailsFieldsProps {
  name: string;
  t: TFunction;
  autoFocus?: boolean;
  label?: string;
  defaultValue?: number | string;
  disabled?: boolean;
}

export const OrganizationNameField = ({
  name,
  t,
  disabled,
  autoFocus,
  label = 'Organization Name'
}: OrganizationDetailsFieldsProps): ReactElement => (
  <FastField name={name}>
    {({ field, meta }: FastFieldProps): ReactElement[] => [
      <TextField
        {...field}
        autoFocus={autoFocus}
        key={`${field.name}_input`}
        label={t(label)}
        fullWidth
        placeholder={t(label)}
        variant="outlined"
        size="small"
        disabled={disabled}
        error={Boolean(meta.touched && meta.error)}
        helperText={meta.touched && meta.error}
        inputProps={{
          'aria-label': t(label)
        }}
      />
    ]}
  </FastField>
);
